import { resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { BankHolidayDate } from './BankHolidayDate';

export const DutyOffRequest = types.compose(
  BaseEntity,
  types
    .model('DutyOffRequest', {
      dutyOffRequestId: types.identifierNumber,
      bankHolidayDateId: types.number,
      pharmacyId: types.number,
    })
    .views((self) => {
      return {
        get bankHolidayDate() {
          return resolveIdentifier(BankHolidayDate, self, self.bankHolidayDateId);
        },
      };
    }),
);
